var map = {
	"./decidim/avatar-multiuser.png": 11778,
	"./decidim/brands/facebook.svg": 3348,
	"./decidim/brands/google.svg": 72717,
	"./decidim/brands/twitter-x.svg": 88798,
	"./decidim/cc-badge.png": 62620,
	"./decidim/decidim-logo.svg": 24368,
	"./decidim/default-avatar.svg": 73576,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 58932,
	"./decidim/icons.svg": 87747,
	"./decidim/pattern.png": 15764,
	"./decidim/placeholder-card-g.svg": 89057,
	"./decidim/placeholder-card-l.svg": 80746,
	"./decidim/placeholder.jpg": 26265,
	"./decidim/remixicon.symbol.svg": 38253,
	"./decidim/vendor/social-share-button/douban.svg": 53308,
	"./decidim/vendor/social-share-button/email.svg": 59129,
	"./decidim/vendor/social-share-button/facebook.svg": 92751,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 97393,
	"./decidim/vendor/social-share-button/hacker_news.svg": 1017,
	"./decidim/vendor/social-share-button/linkedin.svg": 54553,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 28026,
	"./decidim/vendor/social-share-button/pinterest.svg": 66399,
	"./decidim/vendor/social-share-button/reddit.svg": 14403,
	"./decidim/vendor/social-share-button/telegram.svg": 91126,
	"./decidim/vendor/social-share-button/tumblr.svg": 73365,
	"./decidim/vendor/social-share-button/twitter.svg": 97416,
	"./decidim/vendor/social-share-button/vkontakte.svg": 51782,
	"./decidim/vendor/social-share-button/wechat.svg": 83297,
	"./decidim/vendor/social-share-button/whatsapp.svg": 66889,
	"./decidim/vendor/social-share-button/x.svg": 33761,
	"./decidim/vendor/social-share-button/xing.svg": 70927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87447;